import { useEffect } from 'react';

import type { Navigation } from 'api/contentful/contentTypes.cloverdotcom';
import { useSidebar } from 'components/SidebarContext/SidebarContext';
import type { ReferencedEntry } from 'contentful';

export const useSidebarOverride = (sidebarOverride?: ReferencedEntry<Navigation>) => {
  const { setOverride, clearOverride, setIsLoading } = useSidebar();

  useEffect(() => {
    if (sidebarOverride) {
      setOverride(sidebarOverride);
    }

    setIsLoading(false);

    return clearOverride;
  }, [sidebarOverride]);
};
